'use strict';

var _ = require('lodash');
function UserExclusionsToolbarBookmarksService(SystemConstants, featureToggleService) {
  var BOOKMARKS = [{
    label: 'Market Exclusions',
    value: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.EXCLUSION_RULES,
    component: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.EXCLUSION_RULES,
    ifFeatureEnabled: ['DYNAMIC_AVAILABILITY']
  }, {
    label: 'FBC Exclusions',
    value: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FBC_EXCLUSION_RULES,
    component: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FBC_EXCLUSION_RULES,
    ifFeatureEnabled: ['DYNAMIC_AVAILABILITY']
  }, {
    label: 'Fare Exclusions',
    value: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FARE_EXCLUSION_RULES,
    component: SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FARE_EXCLUSION_RULES,
    ifFeatureEnabled: ['FARES_OPTIMIZER']
  }];
  function getBookmarks() {
    return _.filter(BOOKMARKS, featureToggleService.isEnabledBasedOnConfig);
  }
  return {
    getBookmarks: getBookmarks
  };
}
UserExclusionsToolbarBookmarksService.$inject = ['SystemConstants', 'FeatureToggleService'];
module.exports = UserExclusionsToolbarBookmarksService;